import Player from "@vimeo/player";

const players = [];

const checkVimeoVideos = () => {
	let customObserver = new IntersectionObserver(
		(entries) => {
				entries.forEach(entry => {
					if (entry.intersectionRatio >= 0.5 ) {
						[...players].forEach( item => {
							if ( item.element === entry.target ) {
								if ( ! item.element.classList.contains('playing') ) {
									item.element.classList.add('playing');
									item.player.play();
								}
							} else {
								if ( item.element.classList.contains('playing') ) {
									item.element.classList.remove('playing');
									item.player.pause();
								}
							}
						})
					}
				});
		},
		{ threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] },
	);

	[...players].forEach( player => {
		customObserver.observe( player.element );
	});
}

export default () => {
	const vimeoWrap = document.querySelectorAll(".link-vimeo");

	if (!vimeoWrap) return;

	const options = {
		autoplay: true,
		loop: true,
		muted: true,
		controls: false,
	}

	const constplayerReadyPromises = [];

	vimeoWrap.forEach(item => {
		const iframeVimeo = item.querySelector("iframe");
		const player = new Player(iframeVimeo,  options);

		var onPlay = function() {
			const fallbackImage = item.querySelector('.hero__video--fallback-image');
			if ( fallbackImage ) {
				fallbackImage.classList.add('hide');
			}
		}

		constplayerReadyPromises.push(
			player.ready().then( () => {
				player.on('play', onPlay)
				players.push(
					{
						player: player,
						element: item.parentNode,
						status: 'paused',
					}
				);
			})
		)
	});

	Promise.all(constplayerReadyPromises).then(
		() => {
			checkVimeoVideos();
		}
	);
};



// WEBPACK FOOTER //
// ./scripts/modules/vimeo-play.js